import { render, staticRenderFns } from "./DemandByXO.vue?vue&type=template&id=056b65ca"
import script from "./DemandByXO.vue?vue&type=script&lang=js"
export * from "./DemandByXO.vue?vue&type=script&lang=js"
import style0 from "./DemandByXO.vue?vue&type=style&index=0&id=056b65ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports